import ITEM from '../../../../DOM/LIST/item/ITEM.js';
import { LISTITEMELEMENT } from '../../../../../enums/LISTITEMELEMENT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
// Model Structure
export const dtAttr = makeAttrStruct([
    ['name'],
    ['class'],
    ['style']
]);
export const dtData = makeDataStruct([
    ['text', '']
]);
export const dtModel = makeStruct([
    ['attributes', dtAttr],
    ['data', dtData]
]);
// Simplified Model
export function dt(text, className, style) {
    return dtModel(dtAttr(className, style), dtData(text));
}
/** Description Term for a Description List */
export default class DT extends ITEM {
    constructor(node, model) {
        super(node, LISTITEMELEMENT.DT, model);
        this.setInnerHTML(model.data.text);
    }
}
